(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerInner = document.querySelector('.header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		
		if (this.headerIsAlwaysSticky) this.reveal; 
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		//if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  console.log("DOM fully loaded.");

  // -----------------------------------------------------------------
  // Configuration: Use a single variant ID for both the toggle and bundle.
  // -----------------------------------------------------------------
  const TARGET_VARIANT_ID = 44516120461500; // This is both your toggle and bundle variant.

  // -----------------------------------------------------------------
  // Functions to add or remove the target variant (toggle functionality)
  // -----------------------------------------------------------------
  async function addTargetVariantToCart() {
    const payload = {
      id: TARGET_VARIANT_ID,
      quantity: 1  // Add 1 unit when the toggle is checked.
    };
    console.log("Adding target variant payload:", JSON.stringify(payload, null, 2));
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!response.ok) {
        console.error("Error adding target variant:", response.statusText);
      } else {
        console.log("Target variant added to cart successfully.");
      }
    } catch (error) {
      console.error("Error in addTargetVariantToCart:", error);
    }
  }

  async function removeTargetVariantFromCart() {
    let cartResponse = await fetch('/cart.js');
    let cart = await cartResponse.json();

    // Remove all items with the target variant.
    while (cart.items.some(item => item.variant_id == TARGET_VARIANT_ID)) {
      const index = cart.items.findIndex(item => item.variant_id == TARGET_VARIANT_ID);
      if (index === -1) break;
      const lineNumber = index + 1; // Shopify uses 1-based indexing.
      console.log("Removing target variant at line", lineNumber);

      const changeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: lineNumber,
          quantity: 0
        })
      });
      if (!changeResponse.ok) {
        console.error("Error removing target variant:", changeResponse.statusText);
        break;
      }
      cartResponse = await fetch('/cart.js');
      cart = await cartResponse.json();
    }
    console.log("Target variant removed from cart.");
  }

  // -----------------------------------------------------------------
  // Function to remove duplicate target variant line items
  // Keeps the one that carries the payload (i.e. has ParlaySelections)
  // -----------------------------------------------------------------
  async function removeDuplicateToggleItems() {
    let cartResponse = await fetch('/cart.js');
    let cart = await cartResponse.json();

    // Filter all items with the target variant.
    const toggleItems = cart.items.filter(item => item.variant_id == TARGET_VARIANT_ID);
    if (toggleItems.length > 1) {
      // Try to find an item with the payload property.
      let itemToKeep = toggleItems.find(item => item.properties && item.properties.ParlaySelections);
      if (!itemToKeep) {
        // Default to the first one if none has the payload.
        itemToKeep = toggleItems[0];
      }
      // Remove all other duplicates.
      for (let i = 0; i < toggleItems.length; i++) {
        if (toggleItems[i].id !== itemToKeep.id) {
          const index = cart.items.findIndex(item => item.id == toggleItems[i].id);
          if (index !== -1) {
            const lineNumber = index + 1;
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: lineNumber, quantity: 0 })
            });
            console.log("Removed duplicate target variant at line", lineNumber);
          }
        }
      }
    }
  }

  // -----------------------------------------------------------------
  // Debounce function and refreshCart (here we simply reload the page)
  // -----------------------------------------------------------------
  function myDebounce(func, delay) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }
  
  function refreshCart() {
    location.reload();
  }
  const debouncedRefreshCart = myDebounce(refreshCart, 100);

  // -----------------------------------------------------------------
  // Helper function: Gather bundle properties (unchanged)
  // -----------------------------------------------------------------
  function getBundleContents() {
    const selectedProducts = document.querySelectorAll('.bundle-selection');
    const ParlaySelections = [];
  
    selectedProducts.forEach(productElem => {
      const vendor = productElem.dataset.productVendor;
      const type = productElem.dataset.productType;
      const productName = productElem.dataset.productName;
      const variantId = parseInt(productElem.dataset.productVariantId, 10);
  
      // Explicit numeric comparison here ensures accuracy.
      if (variantId !== parseInt(TARGET_VARIANT_ID, 10)) {
        ParlaySelections.push({
          Event: vendor,
          BetEvent: type,
          Bet: productName,
          ID: variantId
        });
      } else {
        console.log(`Excluded TARGET_VARIANT_ID ${variantId} from bundle payload.`);
      }
    });
  
    return ParlaySelections;
  }

  // -----------------------------------------------------------------
  // Function to remove all non-target items from the cart.
  // -----------------------------------------------------------------
  async function removeNonBundleItems() {
    let cartResponse = await fetch('/cart.js');
    let cart = await cartResponse.json();
    while (cart.items.some(item => item.variant_id !== TARGET_VARIANT_ID)) {
      const index = cart.items.findIndex(item => item.variant_id !== TARGET_VARIANT_ID);
      if (index === -1) break;
      const lineNumber = index + 1;
      console.log("Removing non-target product at line", lineNumber);
      const changeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: lineNumber, quantity: 0 })
      });
      if (!changeResponse.ok) {
        console.error("Error clearing item at line", lineNumber, changeResponse.statusText);
        break;
      }
      cartResponse = await fetch('/cart.js');
      cart = await cartResponse.json();
    }
    console.log("All non-target items have been removed.");
  }

  // -----------------------------------------------------------------
  // Function to create the bundle payload for checkout.
  // It uses the target variant's quantity in the cart.
  // -----------------------------------------------------------------
  async function createBundle() {
    // 1. Fetch the current cart.
    let cartResponse = await fetch('/cart.js');
    let cart = await cartResponse.json();
  
    // 2. Capture the quantity of the toggle variant before removing it.
    let toggleVariantQuantity = 0;
    cart.items.forEach(item => {
      if (item.variant_id == TARGET_VARIANT_ID) {  // TARGET_VARIANT_ID is the same as your toggle variant ID.
        toggleVariantQuantity += item.quantity;
      }
    });
    if (toggleVariantQuantity <= 0) {
      toggleVariantQuantity = 1;
    }
    console.log("Captured toggle variant quantity:", toggleVariantQuantity);
  
    // 3. Build the payload for the bundle using the captured quantity.
    const payload = {
      id: TARGET_VARIANT_ID,  // Same as toggle variant.
      quantity: toggleVariantQuantity,
      properties: {
        ParlaySelections: JSON.stringify(getBundleContents())
      }
    };
    console.log("Bundle payload:", JSON.stringify(payload, null, 2));
  
    // 4. Remove the existing toggle variant(s) from the cart.
    await removeTargetVariantFromCart();
    
    // 5. Add the payload line item to the cart.
    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!addResponse.ok) {
        console.error("Error adding bundle product:", addResponse.statusText);
        return;
      } else {
        console.log("Bundle product added successfully.");
      }
    } catch (error) {
      console.error("Error during bundle add:", error);
      return;
    }
  
    // 6. Optionally, remove any non-bundle items from the cart.
    await removeNonBundleItems();
  
    // 7. Redirect to checkout.
    window.location.href = '/checkout';
  }

  // -----------------------------------------------------------------
  // Existing Cart Page Code (cart form, cart notes, etc.)
  // -----------------------------------------------------------------
  const cartForm = document.getElementById('cart');
  let cartNoteElement = document.getElementById('cart-note');
  let donationCheckbox = document.getElementById('agree-donation');
  const cartToggleSwitch = document.getElementById('cart-toggle-switch');

  if (!cartForm) console.error("Cart form not found!");
  if (!cartNoteElement) console.error("Cart note element not found!");
  if (!donationCheckbox) console.error("Donation checkbox not found!");
  if (!cartToggleSwitch) console.error("Cart toggle switch not found!");

  if (!cartForm || !cartNoteElement || !donationCheckbox || !cartToggleSwitch) {
    console.error("One or more required elements are missing. Aborting script execution.");
    return;
  }
  console.log("Found cartForm:", cartForm);
  console.log("Found cartNoteElement:", cartNoteElement);
  console.log("Found donationCheckbox:", donationCheckbox);
  console.log("Found cartToggleSwitch:", cartToggleSwitch);

  const storedToggleState = localStorage.getItem('cartToggleState');
  if (storedToggleState !== null) {
    cartToggleSwitch.checked = (storedToggleState === 'true');
    console.log("Restored toggle state from localStorage:", cartToggleSwitch.checked);
  } else {
    console.log("No stored toggle state found. Using default.");
  }

  const updateSelectWagerVisibility = function() {
    const selectWagerElements = document.querySelectorAll('.select-wager-type');
    const selectWagerShowElements = document.querySelectorAll('.select-wager-type-show');
    console.log("Updating toggle visibility. Toggle state:", cartToggleSwitch.checked);
    
    if (cartToggleSwitch.checked) {
      selectWagerElements.forEach(el => el.classList.remove('parlay-hide'));
      selectWagerShowElements.forEach(el => el.classList.add('parlay-hide'));
    } else {
      selectWagerElements.forEach(el => el.classList.add('parlay-hide'));
      selectWagerShowElements.forEach(el => el.classList.remove('parlay-hide'));
    }
  };

  if (cartToggleSwitch) {
    cartToggleSwitch.addEventListener('change', function(event) {
      event.stopPropagation();
      console.log("Toggle switch changed. New state:", cartToggleSwitch.checked);
      updateSelectWagerVisibility();
      localStorage.setItem('cartToggleState', cartToggleSwitch.checked);
  
      if (cartToggleSwitch.checked) {
        // When checked, add the target variant to the cart.
        addTargetVariantToCart().then(() => {
          debouncedRefreshCart();
        });
      } else {
        // When unchecked, remove the target variant from the cart.
        removeTargetVariantFromCart().then(() => {
          debouncedRefreshCart();
        });
      }
    });
  }
  updateSelectWagerVisibility();

  let cartNoteValue = '';
  const updateCartNoteValue = function(event) {
    if (cartNoteElement) {
      cartNoteValue = cartNoteElement.value.trim();
      console.log("Updated cartNoteValue:", cartNoteValue);
    }
  };

  const debouncedUpdateCartNoteValue = myDebounce(updateCartNoteValue, 300);
  if (cartNoteElement) {
    cartNoteElement.addEventListener('input', debouncedUpdateCartNoteValue);
  }

  const cartContainer = document.querySelector('#CartContainer');
  if (cartContainer) {
    const observer = new MutationObserver(function(mutationsList) {
      console.log("MutationObserver: Detected changes in cart container:", mutationsList);
      updateSelectWagerVisibility();

      const newCartNoteElement = document.getElementById('cart-note');
      if (newCartNoteElement && newCartNoteElement !== cartNoteElement) {
        cartNoteElement = newCartNoteElement;
        cartNoteElement.addEventListener('input', debouncedUpdateCartNoteValue);
        console.log("Re-attached event listener to new cart note element.");
      }
      const newDonationCheckbox = document.getElementById('agree-donation');
      if (newDonationCheckbox && newDonationCheckbox !== donationCheckbox) {
        donationCheckbox = newDonationCheckbox;
        console.log("Updated donation checkbox reference.");
      }
      updateCartNoteValue();
    });
    observer.observe(cartContainer, {
      childList: true,
      subtree: true
    });
  } else {
    console.warn("Cart container (#CartContainer) not found.");
  }

  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      console.log("Pageshow event (persisted): Clearing cart note.");
      if (cartNoteElement) {
        cartNoteElement.value = '';
      }
    }
  });

  cartForm.addEventListener('submit', async function(event) {
    event.preventDefault();
    console.log("Cart form submit triggered.");
  
    const currentCartNoteElement = document.getElementById('cart-note');
    const currentDonationCheckbox = document.getElementById('agree-donation');
    const currentCartNoteValue = currentCartNoteElement ? currentCartNoteElement.value.trim() : '';
  
    console.log("Cart Note Value at submit:", currentCartNoteValue);
  
    if (!currentDonationCheckbox || !currentDonationCheckbox.checked) {
      alert("Please agree to the simulated betting terms before proceeding.");
      return;
    }
  
    if (!currentCartNoteValue) {
      alert("You must list a group to receive your potential payout.");
      return;
    }
  
    // Always update cart note first, regardless of toggle state.
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: currentCartNoteValue })
      });
  
      if (!response.ok) {
        console.error("Fetch error updating cart note:", response.statusText);
        alert("There was an issue updating your cart note. Please try again.");
        return;
      } else {
        console.log("Cart note successfully updated in Shopify.");
      }
    } catch (error) {
      console.error("Error updating cart note:", error);
      alert("An unexpected error occurred while updating your cart. Please try again.");
      return;
    }
  
    if (cartToggleSwitch.checked) {
      await createBundle();  // Create the bundle and proceed to checkout.
    } else {
      // Proceed directly to checkout after successfully updating the cart note.
      window.location.href = '/checkout';
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
